import { cn } from "@/lib/utils";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "success" | "warning" | "error" | "info" | "new" | "brand";
  size?: "sm" | "md";
}

const VARIANT: Record<BadgeProps["variant"] & string, string> = {
  default: "bg-[var(--color-surface-2)] text-[var(--color-text-muted)] border border-transparent",
  success: "bg-[var(--color-success-100)] text-[var(--color-success-700)] border border-transparent",
  warning: "bg-[var(--color-warning-100)] text-[var(--color-warning-700)] border border-transparent",
  error: "bg-[var(--color-error-100)] text-[var(--color-error-700)] border border-transparent",
  info: "bg-[var(--color-info-100)] text-[var(--color-info-700)] border border-transparent",
  new: "bg-[var(--color-signal-100)] text-[var(--color-signal-700)] border border-transparent",
  brand: "bg-[var(--color-accent-strong)] text-[var(--color-accent-fg)] border border-transparent",
};

const SIZE: Record<BadgeProps["size"] & string, string> = {
  sm: "px-2 py-0.5 text-[10px] rounded-md",
  md: "px-2.5 py-0.5 text-xs rounded-md",
};

export function Badge({ className, variant = "default", size = "md", children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 font-semibold tracking-wide",
        VARIANT[variant],
        SIZE[size],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
